<template>
    <div>
        <div class="headline">
            <h3>{{ 'Users in ' + this.location.name}}</h3>
            <search
                :placeholder= "'Search for Users in ' + this.location.name"
                icon="group"
                min_len = '4'
                v-on:searchstr="searchForUsers($event)">

            </search>

        </div>
        <div class="content">
            <ul class="dashboard-box-list">
                <li v-for="(user, i) in users" :key="i">
                    <!-- Overview -->
                    <div class="freelancer-overview manage-candidates">
                        <div class="freelancer-overview-inner">
                            <!-- Avatar -->
                            <div class="freelancer-avatar" style="">
                                <img :src="imgSrc(user)" :alt="`${user.name} profile avatar`"/>
                            </div>
                            <!-- Name -->
                            <div class="freelancer-name">
                                <h4><span class="country-name">{{ user.name }}</span>
                                    <i class="icon-material-outline-check-circle margin-left-4" :class="activeStatusClass(user)" :title="activeStatusTitle(user)"></i>
                                </h4>

                                <!-- Body -->
                                <span><a href="#" onclick="return false;"><i class="icon-material-outline-date-range"></i> {{ memberSince(user) }}</a></span><br/>
                                <span style="">
                                    <a :href="hrefEmail(user)" target="_blank" :title="emailTitle(user)"><i class="user-info icon-material-outline-email margin-left-4"></i></a>
                                    <a :href="hrefWhatsapp(user)" target="_blank" :title="whatsappTitle(user)"><i class="user-info icon-brand-whatsapp margin-left-8"></i></a>
                                    <a :href="`tel:${user.phone_number}`" target="_blank" :title="`Call ${user.name} (${user.phone_number})`"><i class="user-info icon-feather-phone-call margin-left-8"></i></a>
                                </span><br/>
                                <star-rating :rating="user.ratings"></star-rating>


                            </div>

                        </div>
                    </div>

                </li>

            </ul>
            <p class="search-info" v-text="searchInfo"></p>
            <loader v-if="usersLoaded  === 0"></loader>
            <button class="button ripple-effect" v-if="finishedLoading === 0" :key="finishedLoading" v-on:click.prevent="loadUsers()">
                Load More
            </button>
            <br/><br/><br/>

        </div>
    </div>

</template>
<script>
    import {searchUsers} from '../../../../core/services/location-services'
    import Search from "../../../partials/Search"
    import StarRating from "./StarRating";
    import moment from "moment";
    import Loader from "../../../partials/Loader";

    export default {
        name: 'users',
        props: ['country', 'region', 'city'],
        components: {Loader, StarRating, Search},
        data() {
            return {
                users : [],
                usersLoaded : 0,
                currentPage: 0,
                finishedLoading: 0, //notifies when ALL USERS have been loaded from database
                searchTerm: '',
                location: '',
                currentLocation: '',
                searchInfo: '',
            }
        },

        computed: {
        },

        methods : {
            imgSrc(user) {
                return `https://i.pravatar.cc/90?id=${user.id}`;
            },
            activeStatusClass(user) {
                if(user.isActive === 1) {
                    return 'user-active-status';
                } else {
                    return 'user-non-active-status';
                }
            },
            activeStatusTitle(user) {
                if(user.isActive === 1) {
                    return `${user.name} is active`;
                } else {
                    return `${user.name} is not active`;
                }
            },
            memberSince(user) {
               return 'Member Since ' +  moment(user.created_at).format('MMMM, YYYY');
            },
            hrefEmail(user) {
                return `mailto:${user.email}?subject=3H JOBS&body=Good Day ${user.name}%0D%0A%0D%0A<--content-->%0D%0A%0D%0A%0D%0A%0D%0A%0D%0ARegards 3H Jobs`;
            },
            emailTitle(user) {
                return `Email ${user.name} (${user.email})`;
            },
            whatsappTitle(user) {
                return `Whatsapp ${user.name} (${user.phone_number})`;
            },
            hrefWhatsapp(user) {
                return `https://wa.me/${user.phone_number}?text=Hello ${user.name}%0A%0A%0ARegards%203H%20Jobs.`;
            },
            searchForUsers(str) {
              this.searchTerm = str;
              this.currentPage = 0;
              this.users = [];
              this.loadUsers();
            },

            params() {
                let params = {};
                if(this.currentLocation === 'country') {
                    params.country_ids = [this.country.id];
                } else if (this.currentLocation === 'region') {
                    params.region_ids = [this.region.id];
                } else if(this.currentLocation === 'city') {
                    params.city_ids = [this.city.id];
                }
                if(this.searchTerm.length >= 4) {
                    params.searchTerm = this.searchTerm;
                }
                return params;
            },

            b4Load() {
                this.searchInfo = '';
                this.currentPage++;
                this.finishedLoading = 1;
                this.usersLoaded = 0;
            },

            loadUsers() {
                this.b4Load();
                searchUsers(
                    this.params(),
                    this.currentPage
                )
                    .then((response) => {
                        this.usersLoaded = 1;
                        if(typeof response.data.data == "undefined") {
                            this.searchInfo = `No Users in ${this.location.name}`;
                            if(this.searchTerm.length > 1) {
                                this.searchInfo = `No User in ${this.location.name} matches Your Search term '${this.searchTerm}'`;
                            }
                        }
                        if(response.data.data.last_page === response.data.data.current_page) {
                            this.finishedLoading = 1;
                        } else {
                            this.finishedLoading = 0;
                        }

                        this.users = this.users.concat(response.data.data.data);

                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.usersLoaded = 1;
                    });

            }

        },

        created() {
            // Set location to Country or Region
            if(this.country !==  undefined  && this.country !== "") {
                this.location = this.country;
                this.currentLocation = 'country';
            }
            if(this.region !== undefined && this.region !== "") {
                this.location = this.region;
                this.currentLocation = 'region';
            }
            if(this.city !== undefined && this.city !== "") {
                this.location = this.city;
                this.currentLocation = 'city';
            }
            this.loadUsers();

        }
    }
</script>

<style scoped>
    .user-info {
        font-size: 1rem;
        color: #0fbaf1 !important;
    }
    .country-name {
        text-transform: capitalize;
        color: black;
    }
    .country-name::after {
        content: " ";
    }
    .search-info {
        margin: 0 auto;
        text-align: center;
        color: #0fbaf1 !important;
    }
    .user-active-status {
        font-size: 1rem;
        color: green;
    }
    .user-non-active-status {
        font-size: 1rem;
        color: gray;
    }
    .content {
        text-align: center;
    }
    button {
        line-height: 0.5rem !important;
    }
</style>
